import api from '../api';

export const authApi = api.injectEndpoints({
  endpoints: builder => ({
    sendOtp: builder.mutation({
      query: payload => ({
        url: '/api/auth/request/otp',
        method: 'POST',
        body: payload
      })
    }),
    verifyOtp: builder.mutation({
      query: payload => ({
        url: '/api/auth/verify/otp',
        method: 'POST',
        body: payload
      })
    }),
    getPrePopulatedStudentData: builder.query({
      query: () => ({
        url: '/api/tenant/student/fetch/prepopulated/students/summary',
        method: 'GET'
      })
    }),
    sendMobileOtp: builder.query({
      query: ({ mobileNumber, emailId }) => ({
        url: '/api/user/send/mobile/otp',
        method: 'GET',
        params: { mobileNumber, emailId }
      })
    }),
    verifyMobileOtp: builder.query({
      query: ({ mobileNumber, emailId, otp }) => ({
        url: '/api/user/verify/mobile/otp',
        method: 'GET',
        params: { mobileNumber, emailId, otp }
      })
    }),
    validateMobileOtp: builder.query({
      query: mobileNumber => ({
        url: '/api/user/validate/mobile/number',
        method: 'GET',
        params: { mobileNumber }
      })
    }),
    updateProfile: builder.mutation({
      query: payload => ({
        url: '/api/user/profile/update',
        method: 'POST',
        body: payload
      })
    }),
    loginOauthUser: builder.query({
      query: code => ({
        url: `/api/auth/oauth/authentication?encodedUserProfile=${code}`,
        method: 'GET'
      })
    }),
    isEmailMobileAvailable: builder.query({
      query: ({ email, mobile }: { email?: string; mobile?: string } = {}) => {
        let url = '/api/web/auth/isemailmobileavailable';

        const params = new URLSearchParams();

        if (email) {
          params.append('email', email);
        }

        if (mobile) {
          params.append('mobile', mobile);
        }

        if (params.toString()) {
          url += `?${params.toString()}`;
        }

        return {
          url,
          method: 'GET'
        };
      }
    })
  })
});

export const {
  useSendOtpMutation,
  useVerifyOtpMutation,
  useLazyIsEmailMobileAvailableQuery,
  useUpdateProfileMutation,
  useLazyLoginOauthUserQuery,
  useLazySendMobileOtpQuery,
  useLazyVerifyMobileOtpQuery,
  useLazyValidateMobileOtpQuery,
  useLazyGetPrePopulatedStudentDataQuery
} = authApi;
